module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M23.658 19.23C21.578 20.958 18.91 22 16 22s-5.578-1.042-7.658-2.77C3.374 20.926 0 24.212 0 28v2a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-2c0-3.788-3.374-7.074-8.342-8.77zM16 18a8 8 0 0 0 8-8V8A8 8 0 0 0 8 8v2a8 8 0 0 0 8 8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/user-2.js
// module id = 1489
// module chunks = 14